/**
 * 库存状态接口 —— Swift LibraryStore.swift 的 TypeScript 镜像。
 * 仅描述行为契约，具体持久化实现见 store/useLibraryStore.ts（Zustand + localStorage）。
 */

export interface RecentVisit {
  entryID: string;
  visitedAt: string; // ISO8601，对应 Swift Date
}

/** 与 Swift 端一致的常量。 */
export const LIBRARY_HISTORY_LIMIT = 50;
export const LIBRARY_SEARCH_HISTORY_LIMIT = 8;
export const LIBRARY_STORAGE_KEY = 'stardew-companion.library.v1';

export interface LibraryState {
  favoriteIDs: string[];
  recentVisits: RecentVisit[];
  recentSearches: string[];

  isFavorite: (entryID: string) => boolean;
  toggleFavorite: (entryID: string) => void;

  recordVisit: (entryID: string) => void;
  clearHistory: () => void;

  recordSearch: (query: string) => void;
  clearRecentSearches: () => void;
}
